import { render, staticRenderFns } from "./TaskListForm.vue?vue&type=template&id=46858725&scoped=true&"
import script from "./TaskListForm.vue?vue&type=script&lang=js&"
export * from "./TaskListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46858725",
  null
  
)

export default component.exports